import { ApolloError } from '@apollo/client';
import type { ClientOptions } from '@sentry/core';
import { HTTP_STATUS } from 'constants/httpStatus';

type BeforeSend = NonNullable<ClientOptions['beforeSend']>;

const LOCALLY_HANDLED_APOLLO_STATUSES = new Set<number>([
  HTTP_STATUS.UNAUTHORIZED,
  HTTP_STATUS.FORBIDDEN,
  HTTP_STATUS.NOT_FOUND,
]);

export const isLocallyHandledApolloNetworkError = (error: unknown): boolean =>
  error instanceof ApolloError &&
  error.networkError !== null &&
  'statusCode' in error.networkError &&
  LOCALLY_HANDLED_APOLLO_STATUSES.has(error.networkError.statusCode);

export const createBeforeSend =
  (beforeSend?: BeforeSend): BeforeSend =>
  (event, hint) => {
    if (isLocallyHandledApolloNetworkError(hint.originalException)) return null;

    return beforeSend ? beforeSend(event, hint) : event;
  };
